<template>
  <qrcode-stream
    :camera="camera"
    :track="paintBoundingBox"
    @init="onInit"
    @decode="onDecode"
    class="qr-code-reader qr-code-reader-absolute"
  >
    <div class="loading-indicator" v-if="!ready">
      Permita acesso a sua câmera
      <img src="@/assets/images/check-in/acesso-readqrcode.png" alt="arte-permitir-acesso">
    </div>
    <template v-else>
      <div v-if="isReading" class="validation-pending">
        Buscando participante...
      </div>
      <div class="reader-animation" :class="{ 'reader-animation-stop': isReading }">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="scan-header">
        <i class="bx bx-package"></i>
        <span>Guarda Volumes</span>
      </div>
    </template>
  </qrcode-stream>
</template>

<script>
import { QrcodeStream } from 'vue-qrcode-reader'

export default {
  name: 'scan-reader',
  components: { QrcodeStream: QrcodeStream },
  props: {
    onRead: Function
  },
  data: function () {
    return {
      isReading: false,
      ready: false,
      camera: 'auto',
      result: null
    }
  },
  methods: {
    onInit: function (promise) {
      var self = this
      promise
        .then(function () {
          self.ready = true
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    paintBoundingBox: function (detectedCodes, ctx) {
      for (var i = 0; i < detectedCodes.length; i++) {
        var detectedCode = detectedCodes[i]
        var boundingBox = detectedCode.boundingBox
        var x = boundingBox.x
        var y = boundingBox.y
        var width = boundingBox.width
        var height = boundingBox.height

        ctx.lineWidth = 2
        ctx.strokeStyle = '#556ee6'
        ctx.strokeRect(x, y, width, height)
      }
    },
    onDecode: function (content) {
      var self = this
      self.result = content
      self.turnCameraOff()
      self.onRead(content)
        .then(function () {
          // Camera permanece desligada até o usuário clicar em próxima leitura
        })
        .catch(function () {
          self.turnCameraOn()
        })
    },
    turnCameraOn: function () {
      this.camera = 'auto'
      this.isReading = false
    },
    turnCameraOff: function () {
      this.isReading = true
      this.camera = 'off'
    },
    resetCamera: function () {
      this.turnCameraOn()
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-indicator {
  padding-top: 12vh;
  font-weight: 400;
  font-size: 14px;
  text-align: center;

  img {
    margin-top: 35px;
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
}

.validation-pending {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 10px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}

.qr-code-reader.qr-code-reader-absolute {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.scan-header {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(85, 110, 230, 0.9);
  color: #fff;
  padding: 10px 25px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 500;

  i {
    font-size: 24px;
  }
}

.reader-animation {
  $espessura: 2%;
  $comprimento: 34%;

  --color: rgb(85, 110, 230);
  min-width: 200px;
  min-height: 200px;
  width: 40vmin;
  height: 40vmin;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  div:nth-child(-n + 4) {
    position: absolute;
    width: 100%;
    height: 100%;

    &::before, &::after {
      top: 0;
      left: 0;
      position: absolute;
      content: '';
      display: block;
      width: $comprimento;
      height: $espessura;
      background-color: var(--color);
      border-radius: 100vmax;
    }

    &::after {
      height: $comprimento;
      width: $espessura;
    }
  }

  div:nth-child(2) {
    transform: rotate(90deg);
  }

  div:nth-child(3) {
    transform: rotate(180deg);
  }

  div:nth-child(4) {
    transform: rotate(270deg);
  }

  div:nth-child(5) {
    width: 80%;
    margin-left: 10%;
    height: $espessura;
    background-color: var(--color);
    border-radius: 100vmax;
    margin-top: 10%;
    animation: 0.8s linear 0s infinite alternate scanning;
    @keyframes scanning {
      from {
        margin-top: 10%;
      }
      to {
        margin-top: 90%;
      }
    }
  }

  &.reader-animation-stop div:nth-child(5) {
    animation-play-state: paused;
  }
}
</style>
